import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL;
const TOKEN_KEY = import.meta.env.VITE_SESSION_TOKEN_KEY;

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}`,
  timeout: 30000,
});

apiClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized
    }
    return Promise.reject(error);
  },
);

export { apiClient };
